<template>
  <section :style="'margin-bottom: -' + height + 'px;'" :class="['section', 'insights-block', {'is_touching': is_touching }, {'is_expanded': expanded}]" :id="block.anchor ? block.anchor : ('block-' + block.id)" ref="content">
    <div :class="['columns is-variable is-2 is-multiline content-holder']">
      <p @click.prevent="expanded = !expanded" class="insights-block__title"><span class="icon bg-purple">
          <template v-if="expanded">-</template><template v-else>+</template>
      </span>  Insights</p>
      <div class="insights-block__content">
        <div v-for="link, i in block.links" :key="`link-${i}`">
          <router-link :target="link.open_in_blank ? '_blank' : null" v-if="link.is_internal" :to="link.url">{{link.title}}</router-link>
          <a :target="link.open_in_blank ? '_blank' : null" v-else :href="link.url">{{link.title}}</a>
        </div>
      </div>
    </div>
  </section>
</template>
  
<script>
import BlockCommons from '../../mixins/BlockCommons';
import WindowResizeHandler from '../../mixins/WindowResizeHandler';
export default {
  name : 'InsightsBlock',
  mixins : [ BlockCommons, WindowResizeHandler ],
  data()
  {
    return {
      is_touching : false,
      expanded : false,
      height : 0,
    }
  },
  mounted() {
    this.$nextTick().then(() => {
      if (this.$refs.content) {
        if (!this.is_touching) {
          this.height = $(this.$refs.content).outerHeight();
        }
      }
    })
  },
  methods :   {
    handle_window_resize(width)
    {
      if (width <= 1023) {
        this.is_touching = true;
        this.height = 0;
      } else {
        this.is_touching = false;
        this.height = $(this.$refs.content).outerHeight();
      };
    },
  }
}
</script>
<style lang="scss">
.insights-block {
  position: sticky !important;
  top: 63px;
  z-index: 30;
  padding: 2rem;
  width: 15%;
  background-color: white;
  left: 60px;

  .content-holder {
    padding: 40px 0;
    border: #574596 solid;
  }

  &.is_touching {
    width: 100%;
    .insights-block__title {
      align-self: unset;
      .icon {
        display: inline-flex;
      }
    }

    .insights-block__content {
      display: none;
      align-items:unset;

      a {
        text-align: left;
      }
    }

    .content-holder {
      padding: 0;
      border: unset;
    }

    &.is_expanded {
      .insights-block__content {
        display: flex;
      }
    }
  }

  @media screen and (max-width: 768px) {
    top: 50px;
  }

  .insights-block__title {
    color: #574596;
    font-weight: 700 !important;
    align-self: center;
    margin-bottom: 10px;

    .icon {
      display: none;
    }
  }

  .insights-block__content {
    display: flex;
    align-items: center;
    flex-direction: column;

    a {
      color: #574596;
      text-align: center;
    }
  }

  .columns {
    flex-direction: column;
  }
}
</style>
  


// WEBPACK FOOTER //
// src/components/blocks/modules/InsightsBlock.vue